import type { AdminRole } from './types';

export type MobileAdminPermission =
    | 'mobile:read'
    | 'mobile:manage'
    | 'mobile:high-risk';

const grants: Record<AdminRole, ReadonlySet<MobileAdminPermission>> = {
    viewer: new Set(['mobile:read']),
    admin: new Set(['mobile:read', 'mobile:manage']),
    superadmin: new Set(['mobile:read', 'mobile:manage', 'mobile:high-risk']),
};

export function can(role: AdminRole | null | undefined, permission: MobileAdminPermission): boolean {
    return role ? grants[role].has(permission) : false;
}

export function hasMinimumRole(role: AdminRole | null | undefined, minimum: AdminRole): boolean {
    const rank: Record<AdminRole, number> = { viewer: 1, admin: 2, superadmin: 3 };
    return Boolean(role && rank[role] >= rank[minimum]);
}
